// import 'babel-polyfill';

import get from 'lodash/get';
import {store} from './store/store';
import Vue from 'vue';
import Vuetify from 'vuetify';
import vSelect from 'vue-select';
import Toasted from 'vue-toasted';
import Vuelidate from 'vuelidate';
import VTooltip from 'v-tooltip';
import VuejsDialog from 'vuejs-dialog';
import PrettyCheckbox from 'pretty-checkbox-vue';
import eachRight from 'lodash/eachRight';
import replace from 'lodash/replace';
import pl from 'vuetify/lib/locale/pl';
import VuetifyConfirm from 'vuetify-confirm';
import VuetifyToast from 'vuetify-toast-snackbar';
import CreatorComponent from './menu/Creator.vue';
import DayComponent from './menu/Day.vue';
import AddPlanComponent from './menu/modal/plan/add.vue';
import EditPlanComponent from './menu/modal/plan/edit.vue';
import PlanSummaryComponent from './menu/modal/plan/summary';
import CopyPlanComponent from './menu/plan/copy.vue';
import EditFoodModalComponent from './menu/modal/food/edit.vue';
import CreateFoodModalComponent from './menu/modal/food/create';
import FoodSummaryComponent from './menu/modal/food/summary';
import FoodEditComponent from './menu/food/edit.vue';
import CopyFoodComponent from './menu/food/copy.vue';
import SearchSelectComponent from './menu/modal/search/search-select.vue';
import SearchAdvancedComponent from './menu/modal/search/search-advanced.vue';
import SearchComponent from './menu/modal/search/search.vue';
import EmptyModalComponent from './menu/modal/empty.vue';
import ModalComponent from './menu/Modal.vue';
import PlanComponent from './menu/Plan.vue';
import MigratorComponent from './menu/Migrator.vue';
import ShoppingListComponent from './menu/modal/shopping-list/shopping-list.vue';
import PrintComponent from './menu/modal/print/Print.vue';
import ListPagePrintComponent from './menu/modal/print/list-page-print.vue';
import PrintPrescriptionDialog from './menu/modal/print/prescription.dialog.vue';
import CombinePatientsDialog from './menu/modal/print/combine-patients.dialog.vue';
import TemplateCreateComponent from './menu/modal/template/Create.vue';
import LoadingButton from './ux/Button.vue';
import DropDownComponent from './ux/Dropdown.vue';
import CopyProductComponent from './menu/product/copy.vue';
import SchemaFormComponent from './schema/schema.form.vue';
import ResourceTableComponent from './components/resource-table.vue';
import ResourceFormComponent from './components/resource-form.vue';
import TagFormComponent from './tags/tag-form.vue';
import TagsTableComponent from './tags/tags.table.vue';
import FoodTagsTableComponent from './food_tags/food_tags.table.vue';
import FoodTagManageModalComponent from "./food_tags/food-tag-manage-modal.vue";
import ProductsWeightsTableComponent from './products_weights/products_weights.table.vue';
import ProductWeightManageModal from "./products_weights/product-weight-manage-modal.vue";
import RoleFormComponent from './views/administrator/roles/role.form.vue';
import PermissionFormComponent from './views/administrator/roles/permission.form.vue';
import UserImportComponent from './views/administrator/users/user.import';
import SubscriptionFormComponent from './views/administrator/subscriptions/subscription.form';
import OrderFormComponent from './views/administrator/orders/order.form';
import InvoiceFormComponent from './views/administrator/invoices/invoice.form';
import SubscriptionTypeFormComponent from './views/administrator/subscription_types/subscription_type.form';
import AdminSettingsPageComponent from './views/administrator/settings/settings.page';
import AdminStatisticsPageComponent from './views/administrator/statistics/statistics.page';
import AdminTagsPageComponent from './views/administrator/tags/tags.page';
import AdminFoodTagsPageComponent from './views/administrator/food_tags/food_tags.page';
import AdminProductsWeightsPageComponent from './views/administrator/products_weights/products_weights.page';
import IconButtonComponent from './components/icon-button';
import PermissionButtonComponent from './components/permission-button';
import PermissionToolTipComponent from './components/permission-tooltip';
import BaseLayoutView from './views/base-layout';
import VueSanitize from 'vue-sanitize';
import VueExpandableImage from 'vue-expandable-image';
import * as Sentry from '@sentry/vue';
import SettingsCategoryComponent from './components/settings-category';
import ReplaceSearchProductModalComponent from './menu/modal/product/replace-search.vue';
import ReplaceSearchProductComponent from './menu/product/replace-search.vue';
import ReplaceProductModalComponent from './menu/modal/product/replace.vue';
import ReplaceProductComponent from './menu/product/replace.vue';
import ProductsTabelComponent from './views/products/products.table';
import SearchProductModalComponent from './menu/modal/product/search';
import SearchProductComponent from './menu/product/search.vue';
import PatientsTableComponent from './views/patients/patients.table';
import StatisticsTableComponent from './views/administrator/statistics/statistics.table';
import HomePage from "./views/home/HomePage";
import SubscriptionCardComponent from "./views/home/SubscriptionCardComponent";
import ButtonsAndSubscriptionComponent from "./views/home/ButtonsAndSubscriptionComponent";
import UpcomingEvents from "./views/home/UpcomingEvents.vue";
import VideoAndPromotionComponent from "./views/home/VideoAndPromotionComponent";
import LatestListComponent from "./views/home/LatestListComponent";
import PrescriptionsTableComponent from './views/patients/prescription/prescriptions.table';
import PrescriptionManageModalComponent from './views/patients/prescription/prescription-manage-modal';
import SurveysTableComponent from './views/patients/surveys.table';
import AddSurveyModalComponent from './views/patients/survey/add-survey-modal';
import EditQuestionModalComponent from './views/patients/survey/edit-question-modal';
import DataSearchComponent from "./dataSearch/DataSearchComponent";
import ExtendTestSubscriptionComponent from "./views/home/ExtendTestSubscriptionComponent";
import StartDiscountModalComponent from "./views/home/StartDiscountComponent";
import PatientsTableInTemplates from "./views/templates/patients.table";
import PatientManageModal from "./views/patient/information/modals/patient-manage-modal";
import InterviewPage from "./views/patients/interview/interview.page";
import InterviewForm from "./views/patients/interview/interview.form";
import MobileInvitePage from "./views/patients/mobile/invite.page";
import GeneralInformationForm from "./views/patients/interview/general_information.form";
import GeneralInformationPreview from "./views/patients/interview/general_information.preview";
import DiseasesAndSymptomsForm from "./views/patients/interview/diseases_and_symptoms.form";
import DiseasesAndSymptomsPreview from "./views/patients/interview/diseases_and_symptoms.preview";
import AdditionalInfoForm from "./views/patients/interview/additional_info.form";
import AdditionalInfoPreview from "./views/patients/interview/additional_info.preview";
import PreferencesForm from "./views/patients/interview/preferences.form";
import PreferencesPreview from "./views/patients/interview/preferences.preview";
import CustomQuestionsForm from "./views/patients/interview/custom_questions.form";
import CustomQuestionsPreview from "./views/patients/interview/custom_questions.preview";
import NoteManageModal from "./views/note/note-manage-modal";
import MeasurementManageModal from "./views/measurments/measurement-manage-modal";
import MenuManageModal from "./views/menu/menu-manage-modal";
import MenuScaleModal from "./views/menu/menu-scale-modal";
import SharedByMeTable from "./views/settings/sharing/shared_by_me.table";
import SharedWithMeTable from "./views/settings/sharing/shared_with_me.table";
import SharingManageModal from "./views/settings/sharing/sharing-manage-modal";
import IconTooltip from "./components/icon-tooltip";
import OrderInvoiceForm from "./views/order/invoice/invoice.form";
import ScrollableSelect from "./components/scrollable-select.vue";
import ManageProductModal from "./views/products/manage-product-modal";
import ProductDetailsModal from "./views/products/product-details-modal";
import VueSlider from "vue-slider-component";
import 'vue-slider-component/theme/default.css';
import DietitianCalendar from "./views/calendar/dietitian-calendar.page";
import AddEventModal from "./views/calendar/add-event-modal.vue";
import SearchCalendarEventInput from "./views/calendar/search-calendar-event-input.vue";
import 'vue2-timepicker/dist/VueTimepicker.css';
import ManageDiscountCodeModal from "./views/discount-codes/ManageDiscountCodeModal.vue";
import DiscountCodeTable from "./views/discount-codes/DiscountCodeTable.vue";
import IsActive from "./views/discount-codes/IsActive.vue";
import DiscountCodeForm from "./views/subscription/DiscountCodeForm.vue";
import DiscountCodeUsagesTable from "./views/discount-codes/DiscountCodeUsagesTable.vue";
import Editor from '@tinymce/tinymce-vue';
import Recaptcha from './components/recaptcha.vue';
import OtherMenusModal from "./views/mobile-app/menu/other-menus-modal.vue";
import NutrientsForm from "./views/settings/printing/nutrients-form.vue";
import MobileAppDownload from "./components/mobile-app-download.vue";

/**
 * Pages
 */
import SchemasPage from './views/templates/schemas.page.vue';
import TagsPage from './views/templates/tags.page.vue';
import RodoPage from './views/settings/rodo.page.vue';
import TemplatesTableComponent from './views/templates/templates.table.vue';
import ImportDialogComponent from './views/templates/import.dialog.vue';
import ExportSchemaFormComponent from './schema/export.form.vue';
import ManageMeals from './schema/manage.meals.form.vue';
import SummaryModalComponent from './menu/modal/summary/Summary.vue';
import RolesPage from './views/administrator/roles/roles.page.vue';
import UsersPage from './views/administrator/users/users.page.vue';
import OrdersPage from './views/administrator/orders/orders.page';
import SubscriptionSelectionPage from './views/subscription/selection.page';
import SubscriptionSummaryPage from './views/subscription/summary.page';
import SubscriptionOrderPage from './views/subscription/order.page';
import IndividualOrderPage from './views/order/indivudial.page';
import SubscriptionsDialogComponent from './views/administrator/subscriptions/subscriptions.dialog';
import SubscriptionManageDialogComponent from './views/administrator/subscriptions/subscription.manage.dialog';
import SubscriptionTypesPage from './views/administrator/subscription_types/subscription_types.page';
import ProductsPage from './views/products/products.page';
import ImportPatientDialog from './views/templates/import_patient.dialog';
import PatientInformation from './views/patient/information/information.page';
import Note from './views/note/note.page';
import Measurements from './views/measurments/measurement.page';
import MeasurementsTable from './views/measurments/measurement.table';
import BodyCompositionAnalysisTable from './views/measurments/body-composition-analysis.table';
import TemplatesPage from './views/templates/templates.page';
import StartDiscountPage from "./views/pages/start_discount.page";
import CategoriesPage from "./views/administrator/categories/categories.page";
import CategoryManageModal from "./views/administrator/categories/category-manage-modal";
import UserManageModal from "./views/administrator/users/user-manage-modal";
import EducationPage from "./views/administrator/education/education.page.vue";
import EducationManageModal from "./views/administrator/education/education-manage-modal.vue";
import PatientRegisterPage from "./views/patient/register.page";
import PatientLoginPage from "./views/patient/login.page";
import PatientResetPasswordPage from "./views/patient/reset-password.page";
import PatientSetPasswordPage from "./views/patient/set-password.page";
import MobileAppChangeDietitianPage from "./views/mobile-app/change-dietitian.page";
import MobileAppDownloadPage from "./views/mobile-app/download.page";

import * as filters from './filters';
import SettingsPage from './views/settings/settings.page';
import OrdersAndInvoicesPage from './views/settings/orders_and_invoices.page';
import PrintingPage from './views/settings/printing.page';
import ProfilePage from './views/settings/profile.page';
import AppearancePage from './views/settings/appearance.page';
import SharingPage from './views/settings/sharing/sharing.page';
import PatientsPage from './views/patients/patients.page';
import PatientPanelPage from './views/patients/panel.page';
import MenuPage from './views/menu/menu.page';
import MenuTable from './views/menu/menu.table';
import ManageProductLikeablesModal from "./views/patients/interview/manage-product-likeables-modal";
import ManageProductCategoryLikeablesModal from "./views/patients/interview/manage-product-category-likeables-modal";
import ProductCategory from "./views/administrator/categories/product-category";
import moment from 'moment-timezone';
import {round} from "./utils/money";
import DragScroll from "./plugins/dragscroll";
import CalendarSettingsModal from "./views/calendar/calendar-settings-modal.vue";
import Label from "./views/calendar/label.vue";
import EducationTable from "./views/administrator/education/education.table.vue";
import Education from "./views/education/education.page.vue";
import EducationList from "./views/education/education-list.vue";
import EducationCard from "./views/education/education-card.vue";
import ShowEducation from "./views/education/show-education.vue";
import DiscountCodePage from "./views/discount-codes/DiscountCode.page.vue";

Vue.use(Vuetify, {
  theme: {
    primary: '#00a65a',
    secondary: '#FFCDD2',
    accent: '#3F51B5',
    cancel: '#f39c12'
  },
  lang: {
    locales: { pl },
    current: 'pl',
  },
});
Vue.use(VuetifyToast, {
  x: 'right', // default
  y: 'bottom', // default
  color: 'info', // default
  icon: 'info',
  timeout: 3000, // default
  dismissable: true, // default
  autoHeight: false, // default
  multiLine: false, // default
  vertical: false, // default
  shorts: {
    success: {
      color: 'green',
      icon: 'done',
    },
    error: {
      color: 'red',
      dismissable: true,
      multiLine: true,
      icon: 'error',
      timeout: 6000,
      autoHeight: true,
    },
  },
  property: '$toast', // default
});

Vue.use(VueSanitize, {
  allowedTags: ['br'],
  allowedAttributes: {}
});

window.axios = require('axios');
window.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        window.location.reload(true);
      }

      if (error.response.status === 403) {
        window.location.href = '/?authorization_error=true';
      }

      if (error.response.status === 419 && error.response.data.message === 'app.token_expired') {
        window.location.reload(true);
      }
    }

    return Promise.reject(error);
  });

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


export const trans = (string, args) => {
  let value = get(window.i18n, string, string);

  eachRight(args, (paramVal, paramKey) => {
    value = replace(value, `:${paramKey}`, paramVal);
  });

  if (value.length === 0)
    return string;

  return value;
};

Vue.prototype.trans = trans;
Vue.filter('trans', trans);

moment.tz.setDefault('Europe/Warsaw');

Vue.use(VuejsDialog, {
  okText: trans('app.yes'),
  cancelText: trans('app.no'),
});

Vue.use(VuetifyConfirm, {
  buttonTrueText: trans('app.yes'),
  buttonFalseText: trans('app.no'),
  color: 'warning',
  icon: 'warning',
  title: 'Warning',
  width: 350,
  property: '$confirm',
});

Vue.use(VTooltip, {
  defaultInnerSelector: '.vue-tooltip-inner, .vue-tooltip__inner',
  defaultTemplate: '<div class="vue-tooltip" role="tooltip"><div class="vue-tooltip-arrow"></div><div class="vue-tooltip-inner"></div></div>',
  defaultArrowSelector: '.vue-tooltip-arrow, .vue-tooltip__arrow',
  popover: {
    defaultWrapperClass: 'vue-wrapper',
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'vue-tooltip vue-popover',
    defaultInnerClass: 'vue-popover-inner',
  },
});
Vue.use(Toasted, {
  iconPack: 'fontawesome',
  duration: 3000,
  position: 'bottom-right',
});

Vue.toasted.register(
  'info',
  (payload) => {
    return payload.message;
  }, {
    type: 'info',
    icon: 'warning',
  },
);

Vue.toasted.register(
  'error',
  (payload) => {
    if (!payload.message) {
      return 'Ups.. coś poszlo nie tak..';
    }
    return 'Ups.. ' + payload.message;
  }, {
    type: 'error',
    icon: 'warning',
  },
);
Vue.toasted.register(
  'success',
  (payload) => {
    if (!payload.message) {
      return trans('app.success');
    }
    return `${trans('app.success')} ${payload.message}`;
  }, {
    type: 'success',
    icon: 'check',
  },
);

Vue.use(Vuelidate);
Vue.use(PrettyCheckbox);
Vue.use(VueExpandableImage);
Vue.use(DragScroll);

Vue.filter('round', (num, places = 2) => round(num, places));
Vue.filter('integers', num => +(Math.round(num)));
Vue.filter('format_date', filters.formatDate);
Vue.filter('capitalize', filters.capitalize);
Vue.filter('money', (value) => {
  return Number.parseFloat(value)
          .toFixed(2)
          .toString()
          .replace('.', ',')
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' zł';
});
Vue.filter('money_short', (value) => {
  return value.replace(',00', '');
});

/**
 * Components
 */
Vue.component('vue-select', vSelect);
Vue.component('creator', CreatorComponent);
Vue.component('day', DayComponent);
Vue.component('add-plan', AddPlanComponent);
Vue.component('edit-plan', EditPlanComponent);
Vue.component('plan-summary', PlanSummaryComponent);
Vue.component('copy-plan', CopyPlanComponent);
Vue.component('edit-food-modal', EditFoodModalComponent);
Vue.component('create-food-modal', CreateFoodModalComponent);
Vue.component('food-edit', FoodEditComponent);
Vue.component('copy-food', CopyFoodComponent);
Vue.component('food-summary', FoodSummaryComponent);
Vue.component('search-select', SearchSelectComponent);
Vue.component('search-advanced', SearchAdvancedComponent);
Vue.component('search', SearchComponent);
Vue.component('empty', EmptyModalComponent);
Vue.component('modal', ModalComponent);
Vue.component('plan', PlanComponent);
Vue.component('migrator', MigratorComponent);
Vue.component('shopping-list', ShoppingListComponent);
Vue.component('print', PrintComponent);
Vue.component('list-page-print', ListPagePrintComponent);
Vue.component('print-prescription-dialog', PrintPrescriptionDialog);
Vue.component('combine-patients-dialog', CombinePatientsDialog);
Vue.component('template-create', TemplateCreateComponent);
Vue.component('loading-button', LoadingButton);
Vue.component('dropdown', DropDownComponent);
Vue.component('copy-product', CopyProductComponent);
Vue.component('schema-form', SchemaFormComponent);
Vue.component('resource-table', ResourceTableComponent);
Vue.component('resource-form', ResourceFormComponent);
Vue.component('tag-form', TagFormComponent);
Vue.component('tags-table', TagsTableComponent);
Vue.component('food-tags-table', FoodTagsTableComponent);
Vue.component('food-tag-manage-modal', FoodTagManageModalComponent);
Vue.component('products-weights-table', ProductsWeightsTableComponent);
Vue.component('product-weight-manage-modal', ProductWeightManageModal);
Vue.component('role-form', RoleFormComponent);
Vue.component('permission-form', PermissionFormComponent);
Vue.component('user-import', UserImportComponent);
Vue.component('subscription-form', SubscriptionFormComponent);
Vue.component('order-form', OrderFormComponent);
Vue.component('invoice-form', InvoiceFormComponent);
Vue.component('summary-form', SummaryModalComponent);
Vue.component('icon-button', IconButtonComponent);
Vue.component('permission-button', PermissionButtonComponent);
Vue.component('permission-tooltip', PermissionToolTipComponent);
Vue.component('subscription-type-form', SubscriptionTypeFormComponent);
Vue.component('settings-category', SettingsCategoryComponent);
Vue.component('replace-search-product-modal', ReplaceSearchProductModalComponent);
Vue.component('replace-search-product', ReplaceSearchProductComponent);
Vue.component('replace-product-modal', ReplaceProductModalComponent);
Vue.component('replace-product', ReplaceProductComponent);
Vue.component('products-table', ProductsTabelComponent);
Vue.component('search-product-modal', SearchProductModalComponent);
Vue.component('search-product', SearchProductComponent);
Vue.component('patients-table', PatientsTableComponent);
Vue.component('statistics-table', StatisticsTableComponent);
Vue.component('prescriptions-table', PrescriptionsTableComponent);
Vue.component('prescription-manage-modal', PrescriptionManageModalComponent);
Vue.component('surveys-table', SurveysTableComponent);
Vue.component('add-survey-modal', AddSurveyModalComponent);
Vue.component('edit-question-modal', EditQuestionModalComponent);
Vue.component('subscription-card-component', SubscriptionCardComponent);
Vue.component('buttons-and-subscription-card-component', ButtonsAndSubscriptionComponent);
Vue.component('upcoming-events', UpcomingEvents);
Vue.component('video-and-promotion-component', VideoAndPromotionComponent);
Vue.component('latest-list-component', LatestListComponent);
Vue.component('extend-test-subscription-component', ExtendTestSubscriptionComponent);
Vue.component('start-discount-modal-component', StartDiscountModalComponent);
Vue.component('patients-table-in-components', PatientsTableInTemplates);
Vue.component('patient-manage-modal', PatientManageModal);
Vue.component('interview-form', InterviewForm);
Vue.component('general-information-form', GeneralInformationForm);
Vue.component('general-information-preview', GeneralInformationPreview);
Vue.component('diseases-and-symptoms-form', DiseasesAndSymptomsForm);
Vue.component('diseases-and-symptoms-preview', DiseasesAndSymptomsPreview);
Vue.component('additional-info-form', AdditionalInfoForm);
Vue.component('additional-info-preview', AdditionalInfoPreview);
Vue.component('preferences-form', PreferencesForm);
Vue.component('preferences-preview', PreferencesPreview);
Vue.component('custom-questions-form', CustomQuestionsForm);
Vue.component('custom-question-preview', CustomQuestionsPreview);
Vue.component('product-category', ProductCategory);
Vue.component('category-manage-modal', CategoryManageModal);
Vue.component('user-manage-modal', UserManageModal);
Vue.component('manage-product-likeables-modal', ManageProductLikeablesModal);
Vue.component('manage-product-category-likeables-modal', ManageProductCategoryLikeablesModal);
Vue.component('shared-with-me-table', SharedWithMeTable);
Vue.component('shared-by-me-table', SharedByMeTable);
Vue.component('sharing-manage-modal', SharingManageModal);
Vue.component('icon-tooltip', IconTooltip);
Vue.component('order-invoice-form', OrderInvoiceForm);
Vue.component('scrollable-select', ScrollableSelect);
Vue.component('calendar-settings-modal', CalendarSettingsModal);
Vue.component('manage-product-modal', ManageProductModal);
Vue.component('product-details-modal', ProductDetailsModal);
Vue.component('VueSlider', VueSlider);
Vue.component('manage-discount-code-modal', ManageDiscountCodeModal);
Vue.component('discount-code-form', DiscountCodeForm);
Vue.component('editor', Editor);
Vue.component('Recaptcha', Recaptcha);
Vue.component('other-menus-modal', OtherMenusModal);
Vue.component('nutrients-form', NutrientsForm);
Vue.component('mobile-app-download', MobileAppDownload);

/**
 * Pages
 */
Vue.component('base-layout', BaseLayoutView);
Vue.component('schemas-page', SchemasPage);
Vue.component('tags-page', TagsPage);
Vue.component('rodo-page', RodoPage);
Vue.component('templates-table', TemplatesTableComponent);
Vue.component('import-dialog', ImportDialogComponent);
Vue.component('export-menu-form', ExportSchemaFormComponent);
Vue.component('manage-meals-dialog', ManageMeals);
Vue.component('roles-page', RolesPage);
Vue.component('users-page', UsersPage);
Vue.component('orders-page', OrdersPage);
Vue.component('subscription-selection', SubscriptionSelectionPage);
Vue.component('subscription-summary', SubscriptionSummaryPage);
Vue.component('subscription-order', SubscriptionOrderPage);
Vue.component('individual-order', IndividualOrderPage);
Vue.component('subscriptions-dialog', SubscriptionsDialogComponent);
Vue.component('subscription-manage-dialog', SubscriptionManageDialogComponent);
Vue.component('settings-page', SettingsPage);
Vue.component('orders-and-invoices-page', OrdersAndInvoicesPage);
Vue.component('printing-page', PrintingPage);
Vue.component('profile-page', ProfilePage);
Vue.component('appearance-page', AppearancePage);
Vue.component('sharing-page', SharingPage);
Vue.component('patients-page', PatientsPage);
Vue.component('patient-panel-page', PatientPanelPage);
Vue.component('subscription-types-page', SubscriptionTypesPage);
Vue.component('admin-settings-page', AdminSettingsPageComponent);
Vue.component('admin-statistics-page', AdminStatisticsPageComponent);
Vue.component('admin-tags-page', AdminTagsPageComponent);
Vue.component('admin-food-tags-page', AdminFoodTagsPageComponent);
Vue.component('admin-products-weights-page', AdminProductsWeightsPageComponent);
Vue.component('products-page', ProductsPage);
Vue.component('home-page', HomePage);
Vue.component('start-discount-page', StartDiscountPage);
Vue.component('categories-page', CategoriesPage);
Vue.component('data-search-component', DataSearchComponent);
Vue.component('import-patient-dialog', ImportPatientDialog);
Vue.component('interview-page', InterviewPage);
Vue.component('patient-information', PatientInformation);
Vue.component('note', Note);
Vue.component('mobile-invite-page', MobileInvitePage);
Vue.component('measurements', Measurements);
Vue.component('measurements-table', MeasurementsTable);
Vue.component('body-composition-analysis-table', BodyCompositionAnalysisTable);
Vue.component('menu-page', MenuPage);
Vue.component('menu-table', MenuTable);
Vue.component('templates-page', TemplatesPage);
Vue.component('note-manage-modal', NoteManageModal);
Vue.component('measurement-manage-modal', MeasurementManageModal);
Vue.component('menu-manage-modal', MenuManageModal);
Vue.component('menu-scale-modal', MenuScaleModal);
Vue.component('dietitian-calendar', DietitianCalendar);
Vue.component('calendar-label', Label);
Vue.component('add-event-modal', AddEventModal);
Vue.component('search-calendar-event-input', SearchCalendarEventInput);
Vue.component('education-page', EducationPage);
Vue.component('education-manage-modal', EducationManageModal);
Vue.component('education-table', EducationTable);
Vue.component('education', Education);
Vue.component('education-list', EducationList);
Vue.component('education-card', EducationCard);
Vue.component('show-education', ShowEducation);
Vue.component('discount-code-page', DiscountCodePage);
Vue.component('discount-code-table', DiscountCodeTable);
Vue.component('is-active', IsActive);
Vue.component('discount-code-usages', DiscountCodeUsagesTable);
Vue.component('patient-register-page', PatientRegisterPage);
Vue.component('patient-login-page', PatientLoginPage);
Vue.component('patient-reset-password-page', PatientResetPasswordPage);
Vue.component('patient-set-password-page', PatientSetPasswordPage);
Vue.component('mobile-app-change-dietitian-page', MobileAppChangeDietitianPage);
Vue.component('mobile-app-download-page', MobileAppDownloadPage);

Vue.directive('access', {
  update(el, binding, vnode) {
    if (binding.value === true)
      return;

    if (vnode.componentInstance.click) {
      vnode.componentInstance.click = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
    }

    el.setAttribute('data-not-available', true);

  },
});

let handleOutsideClick;

Vue.directive('comment-input-click-outside', {
  bind (el, binding, vnode) {
    handleOutsideClick = ($event) => {
      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          if (typeof excludedEl !== 'undefined') {
            if (excludedEl instanceof Vue) {
              clickedOnExcludedEl = excludedEl.$el.contains($event.target);
            }else {
              clickedOnExcludedEl = excludedEl.contains($event.target);
            }
          }
        }
      });

      if (!el.contains($event.target) && !clickedOnExcludedEl) {
        vnode.context[handler]($event);
      }
    };
    document.addEventListener('click', handleOutsideClick);
  },

  unbind (el, binding, vnode) {
    const { handler, exclude } = binding.value;
    vnode.context[handler] = (() =>{});
    document.removeEventListener('click', handleOutsideClick);
  }
});

Vue.mixin({
  methods: {
    sentryCaptureException: (error) => {
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(error);
      }
    }
  }
});

if (document.getElementById('app')) {
  if (typeof Sentry !== 'undefined') {
    const sentry = document.getElementById('sentry');
    if (sentry.dataset.dsn) {
      Sentry.init({
        Vue: Vue,
        dsn: sentry.dataset.dsn,
        beforeSend(event) {
          //ignore sending errors like
          // {"isTrigger":3,"jQuery321004623735724191147":true,"namespace":"dt","rnamespace":{}...
          if (event.exception) {
            for (let i = 0; i < event.exception.values.length; i++) {
              const error = event.exception.values[i];
              if (error.type === 'Error' && error.value.namespace === 'dt') {
                return null;
              }
              if (error.type === 'Error' && error.value === 'Network Error') {
                return null;
              }
              if (error.type === 'Error' && error.value === 'Request failed with status code 419') {
                return null;
              }
              if (error.type === 'Error' && error.value === 'Request failed with status code 401') {
                return null;
              }
              if (error.type === 'Error' && error.value === 'Request failed with status code 409') {
                return null;
              }
            }
          }
          return event;
        }
      });

      Sentry.setTag('app.fe_version', sentry.dataset.app_version);

      if (Object.keys(currentUser).length > 0) {
        const role = currentUser.roles.length > 0 ? currentUser.roles[0].name : '';

        Sentry.setUser({
          id: currentUser.id,
          email: currentUser.email,
          account_type: currentUser.account_type,
          role: role,
        });
      }
    }
  }

  const app = new Vue({
    store,
    el: '#app',
    created() {
      this.$store.dispatch('FETCH_DICTIONARIES');

      $(document).ajaxError((event, xhr) => {
        if (xhr.readyState !== 4) {
          return;
        }

        this.$toast.error('app.error_occurred');
      });
    },

  });
}
if (document.getElementById('search-input')) {
  const searchInput = new Vue({
    store,
    el: '#search-input',
    created() {
      this.$store.dispatch('FETCH_DICTIONARIES');

      $(document).ajaxError((event, xhr) => {
        if (xhr.readyState !== 4) {
          return;
        }

        this.$toast.error('app.error_occurred');
      });
    },

  });
}
if (document.getElementById('mobile-app')) {
    const mobileApp = new Vue({
        store,
        el: '#mobile-app',
        created() {
            $(document).ajaxError((event, xhr) => {
                if (xhr.readyState !== 4) {
                    return;
                }

                this.$toast.error('app.error_occurred');
            });
        },

    });
}
